import { Row, Col, Form, Input } from 'antd';

const SprayUnitForm = () => {
    return (
        <Row gutter={[16, 16]}>
            {[
                { name: 'asset_id', label: 'Asset ID', required: true, message: 'This field is required', span: 12 },
                { name: 'asset_name', label: 'Asset Name', required: true, message: 'This field is required', span: 12 },
                { name: 'safety_warnings', label: 'Safety Warnings', required: true, message: 'This field is required', span: 12 },
                { name: 'ppe_requirements', label: 'PPE Requirements', required: true, message: 'This field is required', span: 12 },
                { name: 'model_and_make', label: 'Model and Make', required: true, message: 'This field is required', span: 12 },
                { name: 'serial_number', label: 'Serial Number', required: true, message: 'This field is required', span: 12 },
                { name: 'tank_capacity', label: 'Tank Capacity', required: true, message: 'This field is required', span: 12 },
                { name: 'remaining_product_threshold', type: 'number', label: 'Remaining Product Threshold', required: true, message: 'This field is required', span: 12 },
                { name: 'spray_boom_width', label: 'Spray Boom Width', required: true, message: 'This field is required', span: 12 },
                { name: 'nozzle_type_and_count', label: 'Nozzle Type and Count', required: true, message: 'This field is required', span: 12 },
                { name: 'pressure_range', label: 'Pressure Range', required: true, message: 'This field is required', span: 12 },
                { name: 'weather_constraints', label: 'Weather Constraints', required: true, message: 'This field is required', span: 12 },
                { name: 'chemical_compatibility', label: 'Chemical Compatibility', required: true, message: 'This field is required', span: 12 },
            ].map((field) => (
                <Col xs={{ span: 24 }} md={{ span: field.span }} key={field.name}>
                    <Form.Item
                        name={['spray', field.name]}
                        className="isoInputWrapper"
                        label={field.label}
                        rules={[{ required: field.required, message: field.message }]}
                    >
                        <Input size="large" placeholder={field.label} type={field.type || 'text'} />
                    </Form.Item>
                </Col>
            ))}
        </Row>
    );
};

export default SprayUnitForm;